import _regeneratorRuntime from "E:/vcode/AIUSERPC/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "E:/vcode/AIUSERPC/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/web.timers.js";
export default {
  data: function data() {
    return {
      loading: false,
      mobileOrEmail: '',
      password: '',
      //密码
      type: 1,
      verificationCode: '',
      // 验证码
      countdown: 0,
      // 倒计时
      timer: null // 定时器
    };
  },
  methods: {
    tologins: function tologins() {
      var that = this;
      if (that.mobileOrEmail == '' || that.mobileOrEmail == null || that.mobileOrEmail == undefined) {
        return that.$message.error('请输入手机号');
      }
      if (that.verificationCode == '' || that.verificationCode == null || that.verificationCode == undefined) {
        return that.$message.error('请输入验证码');
      }
      that.$api.loginAuthCodeLogin({
        mobile: that.mobileOrEmail,
        authCode: that.verificationCode
      }).then(function (result) {
        console.log('验证码登录返回', result);
        if (result) {
          that.$store.commit('setToken', result.token);
          that.$store.commit('setInfo', result);
          that.loading = false;
          that.$router.push('/item/list');
        }
      });
    },
    sendVerificationCode: function sendVerificationCode() {
      var that = this;
      if (this.countdown > 0) {
        return that.$message.error('请稍后再试');
      }
      // 简单的手机号验证，实际项目中需要更严格的验证
      if (!/^1[3-9]\d{9}$/.test(that.mobileOrEmail)) {
        alert('请输入正确的手机号');
        return;
      }
      that.$api.loginGetAuthCode({
        mobile: that.mobileOrEmail,
        type: 1
      }).then(function (res) {
        if (res) {
          that.$message.success('验证码发送成功');
          that.countdown = 60;
          // 启动倒计时
          that.timer = setInterval(function () {
            if (that.countdown > 0) {
              that.countdown--;
            } else {
              clearInterval(that.timer);
            }
          }, 1000);
          // 这里可以调用接口发送验证码，示例中省略
          console.log('发送验证码给：', that.mobileOrEmail);
        }
      });
    },
    cgeTab: function cgeTab(type) {
      this.type = type;
    },
    // 登录
    tologin: function tologin() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var that, result, param;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              that = _this;
              that.loading = true;
              // console.log(this.mobileOrEmail,this.password)
              that.$store.commit('setToken', 'yunduan');
              param = {
                mobile: _this.mobileOrEmail,
                password: _this.password
              };
              console.log(param, 'param===========');
              _context.next = 7;
              return that.$api.authPasswordLogin(param);
            case 7:
              result = _context.sent;
              console.log(result, 'result===========');
              if (!result) {
                _context.next = 18;
                break;
              }
              that.$store.commit('setToken', result.token);
              that.$store.commit('setInfo', result);
              that.loading = false;
              that.$router.push('/item/list');
              return _context.abrupt("return");
            case 18:
              that.loading = false;
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};